<template>
    <div id="reset-password-page" class="content">
        <h3>Reset your password</h3>
        <form @submit.prevent="submit">
            <p>
                <label>Choose a password:
                    <input type="password" name="password" v-model="updateUser.password" required>
                </label>
            </p>
            <p>
                <label>Confirm your password:
                    <input type="password" name="password" v-model="updateUser.confirm_password" required>
                </label>
            </p>
            <p class="small" v-if="updateUser.password != updateUser.confirm_password">
                Passwords do not match.
            </p>
            <p>
                <button>Submit</button>
            </p>
        </form>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import axios from 'axios'

export default {
    name: 'reset-password-page',
    data() {
        return {
            updateUser: {},
            submitted: false,
        }
    },
    computed: {
        ...mapState(['user']),
    },
    methods: {
        async submit() {
            if (this.updateUser.password != this.updateUser.confirm_password)
                return;

            if (!this.user) {
                let r = await axios.put(`/api/forgot-password/update-pw/${this.$route.query.token}`, {
                    user: this.updateUser,
                })

                if (r.status != 200) {
                    // this.errorMsg = r.data.message
                    return
                }

                // this.submitted = true
                this.$notify.success('Password has been reset. Please log-in below.', 3000)
                this.$router.push('/login')
            }
            else {
                this.updateUser.reset_pw_next = false
                let r = await axios.put(`/api/users/${this.user.id}`, {
                    user: this.updateUser,
                })

                if (r.status != 200) {
                    // this.errorMsg = r.data.message
                    return
                }

                // this.submitted = true
                this.$notify.success('Password has been reset.', 3000)
                this.$router.push('/')
            }
        }
    },
    created() {
        this.$nextTick(() => {
            if (!this.user && !this.$route.query.token) {
                this.$router.push('/login')
            }
        })
    }
}
</script>

<style lang="scss">
@import "../scss/include-media";

#reset-password-page {
    padding: 50px 100px;
    @include media("<=tablet") {
        padding: 50px;
    }
    &.content {
        @include media(">tablet") {
            max-width: 65vw;
        }
    }
}
</style>

